import React from 'react';
import './App.css';
import { Websites } from './views/websites';
import { loadTheme } from '@fluentui/react';
loadTheme({
  palette: {
    themePrimary: '#f64141',
    themeLighterAlt: '#fff7f7',
    themeLighter: '#fddfdf',
    themeLight: '#fcc4c4',
    themeTertiary: '#f98a8a',
    themeSecondary: '#f65656',
    themeDarkAlt: '#dc3939',
    themeDark: '#ba3030',
    themeDarker: '#892424',
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#a19f9d',
    neutralSecondary: '#605e5c',
    neutralPrimaryAlt: '#3b3a39',
    neutralPrimary: '#323130',
    neutralDark: '#201f1e',
    black: '#000000',
    white: '#ffffff',
  }});
function App() {
  return (
    <div className="App">
      <Websites />
    </div>
  );
}

export default App;
